import { formatHtml } from "@trumpf/ux.common-storybook";
import {
    TeaserNewsTemplate,
    TeaserNewsListTemplate,
    newsTeaserData,
} from "./teaser-news.templates";

export default {
    title: "Website/Partial Templates/Teaser/News",
    render: TeaserNewsTemplate.bind({}),
    parameters: {
        docs: {
            source: {
                transform: formatHtml,
            },
        },
    },
};

export const Default = {
    args: {
        variant: "default",
        ...newsTeaserData,
    },
    argTypes: {
        variant: {
            options: ["default", "info-news"],
            control: { type: "radio" },
        },
    },
};

export const List = {
    render: TeaserNewsListTemplate.bind({}),
};
